<div class="row">
  <div class="col">
    <app-breadcrumbs [breadcrumbs]="breadcrumbs()"></app-breadcrumbs>
  </div>
</div>
<div class="row">
  <div class="col">
    <div *ngIf="guideData() != null" class="guide-container bg-green-5 py-8 px-4">
      <div
        [dataLayerParamsClickGA4]="dataLayerParamsClickGA4()"
        appStaticAdClick
        appStaticRedirectClick
        class="row"
      >
        <div class="col prose prose-table:my-0 prose-tr:border-0 prose-hr:my-8">
          <h1
            [innerHTML]="guideData().title.rendered"
            class="text-grey-1"
            id="page-title"
          ></h1>
          <div
            *ngIf="
              guideData().acf.mainIntroduction &&
              guideData().acf.mainIntroduction != null
            "
            class="page-content"
          >
            <div
              [innerHTML]="
                guideData().acf.mainIntroduction
                  | wpMediaUrlFix
                  | wpAnchorLinksUrlFix
                  | safeHtml
              "
              appAddClickActionToLocalLinks
            ></div>
          </div>

          <div *ngIf="guideData().acf.showMainImageOnPostPage" [ngStyle]="{ 'padding-bottom': imageContainerPadding()}"
               class="post-image">
            <app-media-item
              [image]="guideData().acf.mainImage"
              [isPriority]="true"
            ></app-media-item>
          </div>

          <div
            *ngIf="
              guideData().acf.bookingBoxContent &&
              guideData().acf.bookingBoxContent !== ''
            "
            class="page-content booking-box-content-mobile"
          >
            <div
              [innerHTML]="
                guideData().acf.bookingBoxContent
                  | wpMediaUrlFix
                  | wpAnchorLinksUrlFix
                  | safeHtml
              "
              appAddClickActionToLocalLinks
            ></div>
          </div>

          <div
            *ngIf="
              guideData().acf.puffsPlacement === GuidePuffsPlacementEnum.BELOW ||
              (!guideData().acf.showBlog && !guideData().acf.showLinks)
            "
            class="page-content"
          >
            <div
              [innerHTML]="
                guideData().content.rendered
                  | wpMediaUrlFix
                  | wpAnchorLinksUrlFix
                  | safeHtml
              "
              appAddClickActionToLocalLinks
            ></div>
          </div>

          <app-author-block
            [authorName]="guideData().acf.authorName"
            [author]="guideData().acf.author"
            [factChecker]="guideData().acf.factChecker"
            [publishDate]="publishDate()"
            [updateDate]="updateDate()"
          ></app-author-block>

          <h4
            *ngIf="
              guideData().acf.mainBottomBoxTitle &&
              guideData().acf.mainBottomBoxTitle !== ''
            "
            class="small-header-title"
          >
            {{ guideData().acf.mainBottomBoxTitle }}
          </h4>
          <aside>
            <div *ngIf="guideData().acf.showBlog" class="small-puffs">
              <app-blog-puffs-list
                [puffsLimit]="guideData().acf.blogPuffsLimit"
                [tags]="[guideData().acf.blogTag]"
              ></app-blog-puffs-list>
            </div>
          </aside>
          <div *ngIf="guideData().acf.showLinks" class="horizontal-puffs">
            <app-boxed-link
              *ngFor="
                let item of guideLinks();
                let i = index;
                trackBy: trackByMethod
              "
              [index]="i"
              [linkData]="item"
            ></app-boxed-link>
          </div>

          <div
            *ngIf="
              guideData().acf.puffsPlacement === GuidePuffsPlacementEnum.ABOVE
            "
            class="page-content"
          >
            <div
              [innerHTML]="
                guideData().content.rendered
                  | wpMediaUrlFix
                  | wpAnchorLinksUrlFix
                  | safeHtml
              "
              appAddClickActionToLocalLinks
            ></div>
          </div>

          <hr>
          <div>
            <div>
              <img [ngSrc]="logoUrl()" alt="logo" height="32" width="128">
            </div>
          </div>
        </div>
        <div class="col-s prose first-of-type:prose-h2:mt-0">
          <div
            *ngIf="
              guideData().acf.bookingBoxContent &&
              guideData().acf.bookingBoxContent !== ''
            "
            class="page-content booking-box-content-desktop"
          >
            <div
              [innerHTML]="
                guideData().acf.bookingBoxContent | wpMediaUrlFix | safeHtml
              "
              appAddClickActionToLocalLinks
            ></div>
          </div>

          <h4 class="small-header-title">
            {{ guideData().acf.rightColBoxTitle }}
          </h4>
          <div class="page-content">
            <div
              [innerHTML]="
                guideData().acf.rightColContent | wpMediaUrlFix | safeHtml
              "
              appAddClickActionToLocalLinks
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-s">
    <app-sidebar
      *ngIf="guideData() != null"
      [isAdVisible]="true"
      [pageType]="pageType"
    ></app-sidebar>
  </div>
</div>
